import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputGroupModule } from 'primeng/inputgroup';
import { TooltipModule } from 'primeng/tooltip';
import { MessageService } from 'primeng/api';
import * as QRCode from 'qrcode';

export interface GuestLinkSession {
  sessionId: string;
  guestUserIdentity: string;
  guestConnectUrl: string;
}

@Component({
  selector: 'app-guest-link-dialog',
  templateUrl: './guest-link-dialog.component.html',
  styleUrls: ['./guest-link-dialog.component.scss'],
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    InputGroupModule,
    TooltipModule
  ]
})
export class GuestLinkDialogComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() session: GuestLinkSession | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();

  guestLinkQRCode: string = '';

  constructor(private messageService: MessageService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible && this.session) {
      this.generateQRCode();
    }
  }

  async generateQRCode() {
    if (this.session?.guestConnectUrl) {
      try {
        this.guestLinkQRCode = await QRCode.toDataURL(this.session.guestConnectUrl, {
          width: 200,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        });
      } catch (error) {
        console.error('Failed to generate QR code:', error);
        this.guestLinkQRCode = '';
      }
    }
  }

  copyGuestUrl() {
    if (this.session?.guestConnectUrl) {
      navigator.clipboard.writeText(this.session.guestConnectUrl).then(() => {
        this.messageService.add({
          severity: 'success',
          summary: 'Guest Link Copied',
          detail: 'Guest connection URL copied to clipboard'
        });
      }).catch(() => {
        this.messageService.add({
          severity: 'error',
          summary: 'Copy Failed',
          detail: 'Failed to copy guest link to clipboard'
        });
      });
    }
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
